<section class="container">
	<lvr-heading class="text-inverse">
		<span><mat-icon aria-hidden="true" fontIcon="person"></mat-icon>{{ 'client.client_view.title' | transloco }}</span>
	</lvr-heading>
	<h3 class="text-inverse">{{ 'client.client_view.numberOfClients' | transloco }} {{ numberOfActiveAssignments() }}</h3>

	<lvr-client-list
		[clients]="clients()"
		[page]="linkedPage()"
		(pageRequested)="onPageRequested($event)"
	></lvr-client-list>
</section>
